// extracted by mini-css-extract-plugin
module.exports = {"technicalTileWrapper":"TechnicalTile_technicalTileWrapper__dhgAR"};